import { capitalize } from '@sonar-software/sonar-ts-lib';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PeriscopeWorkflowRuleCriteria } from '@periscopes/general/workflow-rules';
import { usePeriscopeMetadata } from '@hooks';
import { MetadataContainer } from '@periscopes/general/metadata';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
export const WorkflowRuleMetadataTab = ({ index, sonarObjectId }) => {
    var _a;
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceWorkflowRule);
    const metadataEntries = useMemo(() => {
        if (!metadata) {
            return [];
        }
        const entries = [
            {
                label: capitalize(COPY_SPECIFIC.OBJECT),
                type: 'string',
                value: metadata.parentDisplayName
            },
            {
                label: COPY_SPECIFIC.EVALUATION_CRITERIA,
                type: 'string',
                value: metadata.evaluationCriteria
            },
            {
                label: COPY_SPECIFIC.RULE_CRITERIA,
                type: 'string',
                value: metadata.ruleCriteria
            }
        ];
        return entries;
    }, [metadata]);
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.WORKFLOW_RULE_INFORMATION }),
        React.createElement(PeriscopeWorkflowRuleCriteria, { criteria: (_a = metadata === null || metadata === void 0 ? void 0 : metadata.criteria) !== null && _a !== void 0 ? _a : [], index: index, isFormula: Boolean(metadata === null || metadata === void 0 ? void 0 : metadata.isFormula) })));
};
